import {select, Store} from '@ngrx/store';
import {BaseDataSource} from '../_base/crud';
import {AppState} from '../reducers';
import {
    selectUsersInStore,
    selectUsersPageLoading,
    selectUsersShowInitWaitingMessage
} from '../selectors/user.selectors';

export class UsersDataSource extends BaseDataSource {
    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectUsersPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectUsersShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectUsersInStore())
        ).subscribe((response) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });
    }
}
